import type { FieldMetadata } from 'models/forms/fields';
import { isDealSplitGridMetadata } from 'models/forms/fields/DealSplitGridMetadata';

import { dealSplitGridCellExtractor } from './dealSplit/dealSplitGridCellExtractor';
import { gridCellExtractor, isGridMetadata } from './gridExtractor';
import { isProductCodesMetadata, productCodesGridCellExtractor } from './productCodes/productCodesGridCellExtractor';
import { isUnderlyingsMetadata, underlyingsCellExtractor } from './underlyings/underlyingsCellExtractor';

export { asGridRows, asGridRowsOrSingle, buildPatchedCellKey, createGridCellExtractor } from './gridExtractor';
export type { GridColumn, GridExtractorOptions } from './gridExtractor';

export type SubKeyExtractor = (
  fieldId: string,
  meta: FieldMetadata,
  previous: unknown,
  current: unknown,
) => readonly string[];

type SubKeyExtractorRegistration = {
  isHandled: (meta: FieldMetadata) => boolean;
  extractor: SubKeyExtractor;
};

export const SUB_KEY_EXTRACTOR_REGISTRATIONS: readonly SubKeyExtractorRegistration[] = [
  { isHandled: isGridMetadata, extractor: gridCellExtractor },
  { isHandled: isDealSplitGridMetadata, extractor: dealSplitGridCellExtractor },
  { isHandled: isProductCodesMetadata, extractor: productCodesGridCellExtractor },
  { isHandled: isUnderlyingsMetadata, extractor: underlyingsCellExtractor },
];

export function getSubKeyExtractor(meta: FieldMetadata): SubKeyExtractor | undefined {
  return SUB_KEY_EXTRACTOR_REGISTRATIONS.find(({ isHandled }) => isHandled(meta))?.extractor;
}
